<div class="message-bubble">
  @if (displayedContent === 'Typing...') {
    <div class="typing-message-wrapper">
      <div class="message-row">
        <div class="message-avatar">
          <img src="assets/icons/chatbot-avatar-icon-new.svg" alt="Bot Avatar" width="50" height="50" />
        </div>
        <div class="typing-dots">
          <span>.</span><span>.</span><span>.</span>
        </div>
      </div>
    </div>
  } @else {
    <div class="message-wrapper">
      <div class="message-row">
        <div class="message-avatar">
          <img src="assets/icons/chatbot-avatar-icon-new.svg" alt="chatbot-icon" width="50" height="50" />
        </div>
        <div class="message-content" sabisCopyToInput #copyToInput="copyToInput">
          @if (displayedContent !== '') {
            <div #messageContent sabisHighlightMathSelection class="custom-content math-larger"
            (click)="onContentClick($event)"
            [innerHTML]="displayedContent.trim() | markdown | safeHtml"></div>
          }

          @if (copyToInput.showCopyToInputIcon) {
            <button class="copy-to-input-btn"
              [style.top.px]="copyToInput.copyBtnPosition.top"
              [style.left.px]="copyToInput.copyBtnPosition.left"
              (pointerdown)="$event.preventDefault()"
              (click)="copyToInput.copySelectionToInput()" title="Copy selection to input">
              <img src="assets/icons/copy-icon.svg" alt="chatbot-icon" width="20" height="20" />
            </button>
          }

          @if (message.isChatbotResponseInterrupted) {
            <button class="retry-button" (click)="regenerateResponse(message)" title="Retry"
              [ngClass]="{ blinking: isBlinking }">
              <span class="retry-text">Looks like the answer got cut off. Let's give it another shot or switch it up to a
              new question!</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="red"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 8px">
                <polyline points="23 4 23 10 17 10"></polyline>
                <polyline points="1 20 1 14 7 14"></polyline>
                <path d="M3.51 9a9 9 0 0114.13-3.36L23 10M1 14l5.36 5.36A9 9 0 0020.49 15"></path>
              </svg>
            </button>
          }
        </div>
      </div>
    </div>
  }
</div>